import { combineLatest, map, switchMap } from 'rxjs';
import { memo } from '../util/index.js';
const DEFAULT_FLAGS = {
  withController: true,
  withPrefs: true
};
export function waitingInfo(instanceId, api) {
  return memo(instanceId, function () {
    let flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FLAGS;
    return combineLatest([api.derive.staking.validators(), api.derive.staking.stashes()]).pipe(switchMap(_ref => {
      let [{
        nextElected
      }, stashes] = _ref;
      const elected = nextElected.map(a => a.toString());
      const waiting = stashes.filter(v => !elected.includes(v.toString()));
      return api.derive.staking.queryMulti(waiting, flags).pipe(map(info => ({
        info,
        waiting
      })));
    }));
  });
}